import { API } from '@unboared/react';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { excludeGamesForClient } from '~/config/airports.config';
import { CHANGE_GAME_TIMEOUT_IN_MS, RANDOM_GAME_IDS, TIME_AFTER_NO_GAMEPAD_IN_MS } from '~/config/global.config';
import { reloadScreen } from '~/unboared/config/screenSocketAudit';

function chooseRandomGame(pool: string[], avoidList: string[] = []): string | undefined {
    // Pool vide (un client exclurait tous les jeux de rotation) → rien à choisir.
    if (pool.length === 0) return undefined;
    // Ne jamais éviter le dernier jeu si le pool ne contient que lui (sinon boucle infinie).
    const candidates = pool.filter((id) => !avoidList.includes(id));
    const list = candidates.length > 0 ? candidates : pool;
    const randomIndex = Math.floor(Math.random() * list.length);
    return list[randomIndex];
}

export function useRandomGameReload(active: boolean, oldGameID?: string, clientID?: string) {
    const [, setSearchParams] = useSearchParams();

    useEffect(() => {
        function reloadPage() {
            if (API.getGamepadIDs().length === 0) {
                const pool = excludeGamesForClient(RANDOM_GAME_IDS, clientID);
                const newGameID = chooseRandomGame(pool, oldGameID ? [oldGameID] : []);
                if (!newGameID) return; // aucun jeu disponible : ne pas recharger sur un game=undefined
                setSearchParams((prev) => {
                    const newParams = new URLSearchParams(prev);
                    newParams.set('game', newGameID);
                    return newParams;
                });
                reloadScreen('rotation');
            }
        }

        let timeout: NodeJS.Timeout;
        let timeout2: NodeJS.Timeout;

        if (active) {
            API.onDisconnect(() => {
                if (API.getGamepadIDs().length === 0) {
                    timeout = setTimeout(reloadPage, TIME_AFTER_NO_GAMEPAD_IN_MS);
                }
            });
            timeout2 = setInterval(reloadPage, CHANGE_GAME_TIMEOUT_IN_MS);
        }
        return () => {
            if (timeout) clearTimeout(timeout);
            if (timeout2) clearTimeout(timeout2);
        };
    }, [active]);
}
